import URI from 'urijs';
import Storage from '@/js/libs/Storage';

export default class QueryParser {
    constructor(key) {
        const uri = URI(window.location.href);
        const queryObject = QueryParser.parseURL(uri);

        this.uri = uri.removeQuery(queryObject);
        this.key = 'app.query.' + key;
        this.query = {...Storage.get(this.key, {}), ...queryObject};

        this.persist();
    }

    parse(params) {
        this.query = {...this.query, ...params};

        return this.persist();
    }

    persist() {
        Storage.set(this.key, this.query);

        const url = this.uri.addQuery(this.query).toString();

        if (window.app.$appHistory) {
            window.app.$appHistory.replaceItem(url);
        }

        this.uri = this.uri.removeQuery(this.query);

        return this.query;
    }

    static parseURL(uri) {
        const query = uri.query(true);

        // default values
        query.scheduled = query.scheduled || 0;
        query.show_all = query.show_all || 0;
        query.page = query.page || 1;
        query.queue_id = query.queue_id || null;
        query.workflow_id = query.workflow_id || null;

        return query;
    }
}
